module.exports = __webpack_public_path__ + "static/media/edit-account.ad748532.svg";